/* LUMLY Dancefloor: pista interattiva, frase che si illumina, calcolatore della pista */
(function () {
  if (window.__lumlyDf) return; window.__lumlyDf = 1;
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DPR = Math.min(window.devicePixelRatio || 1, 2);
  var AMBER = [245, 166, 35];

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function hash(a, b) { var s = Math.sin(a * 127.1 + b * 311.7) * 43758.5453; return s - Math.floor(s); }
  function hsl(h, s, l) {
    h = ((h % 360) + 360) % 360 / 360;
    function f(n) { var k = (n + h * 12) % 12, a = s * Math.min(l, 1 - l); return l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1)); }
    return [f(0) * 255, f(8) * 255, f(4) * 255];
  }
  function rgb(c, a) { return 'rgba(' + (c[0] | 0) + ',' + (c[1] | 0) + ',' + (c[2] | 0) + ',' + (a == null ? 1 : a) + ')'; }

  /* carattere 5x7 per il testo sulla PixelFloor */
  var FONT = {
    L: ['10000', '10000', '10000', '10000', '10000', '10000', '11111'],
    U: ['10001', '10001', '10001', '10001', '10001', '10001', '01110'],
    M: ['10001', '11011', '10101', '10101', '10001', '10001', '10001'],
    Y: ['10001', '10001', '01010', '00100', '00100', '00100', '00100'],
    ' ': ['000', '000', '000', '000', '000', '000', '000']
  };
  function textCols(str) {
    var cols = [];
    for (var i = 0; i < str.length; i++) {
      var g = FONT[str[i]], w = g[0].length;
      for (var x = 0; x < w; x++) { var c = []; for (var y = 0; y < 7; y++) c.push(g[y][x] === '1'); cols.push(c); }
      cols.push([0, 0, 0, 0, 0, 0, 0]);
    }
    return cols;
  }
  var TXT = textCols('LUMLY    ');

  /* ---------------- Pista interattiva ---------------- */
  function Lab(root) {
    var cv = root.querySelector('canvas'); if (!cv) return;
    var ctx = cv.getContext('2d');
    var tabs = [].slice.call(root.querySelectorAll('[data-df-tab]'));
    var panes = [].slice.call(root.querySelectorAll('[data-df-pane]'));
    var stage = root.querySelector('.dfl-stage');
    var COLS = 10, ROWS = 7, Z0 = 2.2, K = 8;
    var W = 0, H = 0, f = 1, hz = 0, hh = 1, P = null, NX = COLS * K + 1;
    var mode = tabs.length ? tabs[0].getAttribute('data-df-tab') : 'mirror';
    var modeT = performance.now(), AUTO = 7000, autoStart = performance.now(), auto = !RM;
    var visible = false, raf = 0, ripples = [], lastRip = null, lastPointer = 0, stepT = 0, stepN = 0;

    function proj(x, z) { var d = z + Z0; return [W / 2 + x * f / d, hz + hh * f / d]; }
    function unproj(sx, sy) {
      if (sy <= hz + 1) return null;
      var d = hh * f / (sy - hz), z = d - Z0, x = (sx - W / 2) * d / f;
      if (z < 0 || z > ROWS || x < -COLS / 2 || x > COLS / 2) return null;
      return [x, z];
    }
    function resize() {
      var r = cv.getBoundingClientRect(); if (!r.width) return;
      W = r.width; H = r.height;
      cv.width = Math.round(W * DPR); cv.height = Math.round(H * DPR);
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      f = W * (W < 600 ? 0.62 : 0.56) * Z0 / (COLS / 2);
      hz = H * 0.05; hh = (H - hz) * Z0 / f;
      var NZ = ROWS * K + 1; P = new Float32Array(NX * NZ * 2);
      for (var j = 0; j < NZ; j++) for (var i = 0; i < NX; i++) {
        var p = proj(i / K - COLS / 2, j / K); P[(j * NX + i) * 2] = p[0]; P[(j * NX + i) * 2 + 1] = p[1];
      }
      draw(performance.now());
    }
    function cellPath(i, j) {
      var a = (j * NX + i) * 2, b = a + 2, c = a + NX * 2 + 2, d = a + NX * 2;
      ctx.moveTo(P[a], P[a + 1]); ctx.lineTo(P[b], P[b + 1]); ctx.lineTo(P[c], P[c + 1]); ctx.lineTo(P[d], P[d + 1]); ctx.closePath();
    }
    function fog(z) { return 1 - (z / ROWS) * 0.5; }

    /* anelli dell'effetto specchio 3D: tunnel di punti luminosi in ogni pannello */
    function rings(t, warm, onFn) {
      ctx.globalCompositeOperation = 'lighter';
      ctx.lineCap = 'round';
      var R = 5, ph = (t * 0.00032) % 1;
      for (var tj = ROWS - 1; tj >= 0; tj--) for (var ti = 0; ti < COLS; ti++) {
        var on = onFn ? onFn(ti, tj) : 1; if (on <= 0.01) continue;
        var cx = ti - COLS / 2 + 0.5, cz = tj + 0.5, u = f / (cz + Z0);
        var mix = 0.5 + 0.5 * Math.sin(t * 0.0006 + (ti + tj) * 0.55);
        var col = warm ? [255, 226 + 14 * mix, 190 + 30 * mix] : [AMBER[0] + 10 * mix, AMBER[1] + 60 * mix, AMBER[2] + 120 * mix];
        for (var r = 0; r < R; r++) {
          var s = ((r + ph * 1) % R) / R; s = 1 - s; var hs = 0.44 * (0.12 + 0.88 * s);
          var a = Math.pow(s, 1.7) * on * fog(cz);
          var p1 = proj(cx - hs, cz - hs), p2 = proj(cx + hs, cz - hs), p3 = proj(cx + hs, cz + hs), p4 = proj(cx - hs, cz + hs);
          ctx.beginPath(); ctx.moveTo(p1[0], p1[1]); ctx.lineTo(p2[0], p2[1]); ctx.lineTo(p3[0], p3[1]); ctx.lineTo(p4[0], p4[1]); ctx.closePath();
          ctx.setLineDash([0, Math.max(2.2, u * 0.075)]);
          ctx.lineWidth = Math.max(1, u * 0.032); ctx.strokeStyle = rgb(col, a); ctx.stroke();
          if (r % 2 === 0) { ctx.setLineDash([]); ctx.lineWidth = Math.max(2, u * 0.09); ctx.strokeStyle = rgb(col, a * 0.09); ctx.stroke(); }
        }
      }
      ctx.setLineDash([]);
      ctx.globalCompositeOperation = 'source-over';
    }
    function cells(fn) {
      for (var j = ROWS * K - 1; j >= 0; j--) {
        var z = (j + 0.5) / K, fg = fog(z);
        for (var i = 0; i < COLS * K; i++) {
          var c = fn(i, j, (i + 0.5) / K - COLS / 2, z);
          if (!c) continue;
          ctx.beginPath(); cellPath(i, j); ctx.fillStyle = rgb([c[0] * fg, c[1] * fg, c[2] * fg]); ctx.fill();
        }
      }
    }
    function seams(alpha, every) {
      ctx.strokeStyle = 'rgba(0,0,0,' + alpha + ')';
      for (var i = 0; i <= COLS * K; i += every) {
        var a = (0 * NX + i) * 2, b = (ROWS * K * NX + i) * 2;
        ctx.lineWidth = i % K === 0 ? 2 : 0.7;
        ctx.beginPath(); ctx.moveTo(P[a], P[a + 1]); ctx.lineTo(P[b], P[b + 1]); ctx.stroke();
      }
      for (var j = 0; j <= ROWS * K; j += every) {
        var c = (j * NX) * 2, d = (j * NX + COLS * K) * 2;
        ctx.lineWidth = j % K === 0 ? 2 : 0.7;
        ctx.beginPath(); ctx.moveTo(P[c], P[c + 1]); ctx.lineTo(P[d], P[d + 1]); ctx.stroke();
      }
    }
    function tiles(fill) {
      ctx.fillStyle = fill;
      for (var tj = 0; tj < ROWS; tj++) for (var ti = 0; ti < COLS; ti++) {
        var x = ti - COLS / 2, g = 0.03;
        var p1 = proj(x + g, tj + g), p2 = proj(x + 1 - g, tj + g), p3 = proj(x + 1 - g, tj + 1 - g), p4 = proj(x + g, tj + 1 - g);
        ctx.beginPath(); ctx.moveTo(p1[0], p1[1]); ctx.lineTo(p2[0], p2[1]); ctx.lineTo(p3[0], p3[1]); ctx.lineTo(p4[0], p4[1]); ctx.closePath(); ctx.fill();
      }
    }

    function drawMirror(t) { tiles('#0a0a0c'); rings(t, false); }
    function drawFree(t) {
      var e = t - modeT;
      tiles('#0b0b0d');
      rings(t, true, function (ti, tj) {
        var d = Math.hypot(ti - COLS / 2 + 0.5, tj - 1) * 0.16 + hash(ti, tj) * 0.5;
        return clamp((e / 1000 - d) * 2.2, 0, 1);
      });
    }
    function drawPixel(t) {
      var s = t / 1000, off = Math.floor(s * 16), j0 = 7;
      cells(function (i, j, x, z) {
        var gy = 6 - Math.floor((j - j0) / 3);
        if (gy >= 0 && gy <= 6 && j >= j0) {
          var col = TXT[(Math.floor((i + off) / 3)) % TXT.length];
          if (col[gy]) return [255, 246, 228];
        }
        var v = Math.sin(x * 0.55 + s * 1.3) + Math.sin(z * 0.7 - s * 0.9) + Math.sin((x + z) * 0.32 + s * 0.6);
        var c = hsl(v * 46 + s * 24 + 20, 0.8, 0.16 + 0.07 * Math.sin(v * 2));
        return c;
      });
      seams(0.6, 1);
    }
    /* StarFloor: superficie lucida con micro luci che scintillano */
    function drawStar(t) {
      tiles('#0b0b0e');
      ctx.globalCompositeOperation = 'lighter';
      var s = t / 1000;
      for (var tj = ROWS - 1; tj >= 0; tj--) for (var ti = 0; ti < COLS; ti++) {
        var u = f / (tj + 0.5 + Z0), fg = fog(tj + 0.5);
        for (var k = 0; k < 16; k++) {
          var hx = hash(ti * 17 + k, tj * 31 + k * 3), hz2 = hash(ti * 7 + k * 5, tj * 13 + k);
          var tw = 0.5 + 0.5 * Math.sin(s * (1.2 + hash(k, ti + tj) * 2.6) + hx * 40);
          tw = Math.pow(tw, 3);
          var p = proj(ti - COLS / 2 + 0.06 + hx * 0.88, tj + 0.06 + hz2 * 0.88);
          var r = Math.max(0.6, u * 0.012) * (0.6 + tw);
          var warm = hash(k, ti * tj + 3) > 0.7;
          ctx.fillStyle = warm ? 'rgba(255,214,150,' + (0.15 + 0.85 * tw) * fg + ')' : 'rgba(235,242,255,' + (0.15 + 0.85 * tw) * fg + ')';
          ctx.beginPath(); ctx.arc(p[0], p[1], r, 0, 6.283); ctx.fill();
          if (tw > 0.7) { ctx.fillStyle = 'rgba(255,255,255,' + 0.08 * tw * fg + ')'; ctx.beginPath(); ctx.arc(p[0], p[1], r * 5, 0, 6.283); ctx.fill(); }
        }
      }
      ctx.globalCompositeOperation = 'source-over';
    }
    /* ColorFloor: pannelli RGB a colori pieni, a tempo */
    function tileFill(ti, tj, col) {
      var x = ti - COLS / 2, g = 0.035;
      var p1 = proj(x + g, tj + g), p2 = proj(x + 1 - g, tj + g), p3 = proj(x + 1 - g, tj + 1 - g), p4 = proj(x + g, tj + 1 - g);
      ctx.fillStyle = col; ctx.beginPath(); ctx.moveTo(p1[0], p1[1]); ctx.lineTo(p2[0], p2[1]); ctx.lineTo(p3[0], p3[1]); ctx.lineTo(p4[0], p4[1]); ctx.closePath(); ctx.fill();
    }
    function drawColor(t) {
      var s = t / 1000, beat = Math.floor(s * 2.2), ph = (s * 2.2) % 1;
      var pal = [[245, 166, 35], [235, 60, 120], [40, 200, 230], [140, 80, 240], [255, 230, 190], [60, 220, 140]];
      for (var tj = ROWS - 1; tj >= 0; tj--) for (var ti = 0; ti < COLS; ti++) {
        var pat = Math.floor(beat / 8) % 3, idx;
        if (pat === 0) idx = (ti + tj + beat) % pal.length;
        else if (pat === 1) idx = (Math.floor(Math.hypot(ti - COLS / 2 + 0.5, tj - ROWS / 2 + 0.5)) + beat) % pal.length;
        else idx = Math.floor(hash(ti + beat * 3, tj) * pal.length);
        var c = pal[idx], k = (0.55 + 0.45 * (1 - ph)) * fog(tj + 0.5);
        tileFill(ti, tj, rgb([c[0] * k, c[1] * k, c[2] * k]));
      }
    }
    /* StepFloor: il pannello si accende sotto il passo */
    var steps = {};
    function stepAt(x, z) { var ti = Math.floor(x + COLS / 2), tj = Math.floor(z); if (ti < 0 || tj < 0 || ti >= COLS || tj >= ROWS) return; steps[ti + ',' + tj] = performance.now(); }
    function drawStep(t) {
      if (t - lastPointer > 2200 && !RM && t - stepT > 420) {
        stepT = t; stepN++;
        var T = stepN * 0.45, px = 3.6 * Math.sin(T * 0.37), pz = 3.4 + 2.6 * Math.sin(T * 0.23 + 1);
        stepAt(px + (stepN % 2 ? 0.3 : -0.3), pz);
      }
      for (var tj = ROWS - 1; tj >= 0; tj--) for (var ti = 0; ti < COLS; ti++) {
        var st = steps[ti + ',' + tj], a = st ? Math.max(0, 1 - (t - st) / 1400) : 0, fg = fog(tj + 0.5);
        var base = [12, 12, 14], c = [base[0] + 233 * a, base[1] + 154 * a, base[2] + 21 * a];
        tileFill(ti, tj, rgb([c[0] * fg, c[1] * fg, c[2] * fg]));
        if (a > 0.05) {
          ctx.globalCompositeOperation = 'lighter';
          var x = ti - COLS / 2, g = 0.035, p1 = proj(x + g, tj + g), p2 = proj(x + 1 - g, tj + g), p3 = proj(x + 1 - g, tj + 1 - g), p4 = proj(x + g, tj + 1 - g);
          ctx.strokeStyle = 'rgba(255,220,160,' + 0.6 * a + ')'; ctx.lineWidth = 2;
          ctx.beginPath(); ctx.moveTo(p1[0], p1[1]); ctx.lineTo(p2[0], p2[1]); ctx.lineTo(p3[0], p3[1]); ctx.lineTo(p4[0], p4[1]); ctx.closePath(); ctx.stroke();
          ctx.globalCompositeOperation = 'source-over';
        }
      }
    }
    function addRip(x, z, amp) { ripples.push({ x: x, z: z, t: performance.now(), a: amp || 1 }); if (ripples.length > 14) ripples.shift(); }
    function drawTouch(t) {
      var s = t / 1000;
      if (t - lastPointer > 2200 && !RM && t - stepT > 480) {
        stepT = t; stepN++;
        var T = stepN * 0.5, px = 3.4 * Math.sin(T * 0.33), pz = 2.6 + 1.8 * Math.sin(T * 0.21 + 1);
        var side = stepN % 2 ? 0.2 : -0.2; addRip(px + side, pz, 0.85);
      }
      var live = [];
      for (var k = 0; k < ripples.length; k++) { var a = (t - ripples[k].t) / 1000; if (a < 3.2) live.push([ripples[k].x, ripples[k].z, a, ripples[k].a]); }
      ripples = ripples.filter(function (r) { return (t - r.t) < 3200; });
      cells(function (i, j, x, z) {
        var c = 0.5 + 0.5 * Math.sin(x * 1.3 + s * 0.9) * Math.sin(z * 1.1 - s * 0.7);
        var r = 4 + 6 * c, g = 20 + 26 * c, b = 32 + 40 * c, w = 0;
        for (var k = 0; k < live.length; k++) {
          var L = live[k], dx = x - L[0], dz = z - L[1], d = Math.sqrt(dx * dx + dz * dz), rad = L[2] * 1.7;
          w += L[3] * Math.exp(-L[2] * 1.1) * (Math.exp(-((d - rad) * (d - rad)) / 0.035) + 1.4 * Math.exp(-d * d * 9) * Math.exp(-L[2] * 3));
        }
        w = Math.min(w, 1.4);
        return [r + 150 * w, g + 220 * w, b + 230 * w];
      });
      seams(0.5, 2);
    }

    function draw(t) {
      if (!P) return;
      ctx.clearRect(0, 0, W, H);
      var gl = ctx.createRadialGradient(W / 2, hz + H * 0.2, 0, W / 2, hz + H * 0.2, W * 0.6);
      var glc = mode === 'touch' ? '40,120,160' : (mode === 'pixel' || mode === 'color') ? '120,60,140' : mode === 'star' ? '160,180,230' : '245,166,35';
      gl.addColorStop(0, 'rgba(' + glc + ',.10)'); gl.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = gl; ctx.fillRect(0, 0, W, H);
      if (mode === 'mirror') drawMirror(t);
      else if (mode === 'free') drawFree(t);
      else if (mode === 'pixel') drawPixel(t);
      else if (mode === 'star') drawStar(t);
      else if (mode === 'color') drawColor(t);
      else if (mode === 'step') drawStep(t);
      else drawTouch(t);
      /* dissolvenza verso il fondo della sala */
      var fy = proj(0, ROWS)[1];
      var g = ctx.createLinearGradient(0, fy - 4, 0, fy + H * 0.14);
      g.addColorStop(0, 'rgba(0,0,0,1)'); g.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, fy + H * 0.14);
      /* passaggio tra un effetto e l'altro */
      var e = (t - modeT) / 650;
      if (e < 1) { ctx.fillStyle = 'rgba(0,0,0,' + (1 - e) * (1 - e) + ')'; ctx.fillRect(0, 0, W, H); }
    }

    function setMode(m, user) {
      if (!m) return;
      mode = m; modeT = performance.now(); autoStart = modeT; ripples = []; lastRip = null; steps = {};
      if (user) auto = false;
      tabs.forEach(function (b) { var on = b.getAttribute('data-df-tab') === m; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); if (!on) b.style.removeProperty('--p'); });
      panes.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-df-pane') === m); });
      root.setAttribute('data-mode', m);
      if (m === 'touch') { addRip(0, 2.5, 1); }
      if (RM) draw(modeT + 2600);
    }
    tabs.forEach(function (b) { b.addEventListener('click', function () { setMode(b.getAttribute('data-df-tab'), true); }); });

    function pt(e) { var r = cv.getBoundingClientRect(); return unproj(e.clientX - r.left, e.clientY - r.top); }
    cv.addEventListener('pointermove', function (e) {
      if (mode !== 'touch' && mode !== 'step') return;
      var p = pt(e); if (!p) return; lastPointer = performance.now(); autoStart = lastPointer;
      if (mode === 'step') { stepAt(p[0], p[1]); if (RM) draw(performance.now()); return; }
      if (!lastRip || Math.hypot(p[0] - lastRip[0], p[1] - lastRip[1]) > 0.55) { addRip(p[0], p[1], 0.9); lastRip = p; }
      if (RM) draw(performance.now());
    });
    cv.addEventListener('pointerdown', function (e) {
      if (mode !== 'touch' && mode !== 'step') return;
      var p = pt(e); if (!p) return; lastPointer = performance.now(); auto = false;
      if (mode === 'step') { stepAt(p[0], p[1]); if (RM) draw(performance.now()); return; }
      addRip(p[0], p[1], 1.3); if (RM) draw(performance.now());
    });

    function loop(t) {
      raf = 0; if (!visible || document.hidden) return;
      draw(t);
      if (auto && tabs.length > 1) {
        var p = (t - autoStart) / AUTO;
        var cur = tabs.filter(function (b) { return b.classList.contains('is-on'); })[0];
        if (cur) cur.style.setProperty('--p', Math.min(p, 1).toFixed(3));
        if (p >= 1) {
          var idx = tabs.indexOf(cur), nx = tabs[(idx + 1) % tabs.length];
          if (cur) cur.style.removeProperty('--p');
          setMode(nx.getAttribute('data-df-tab'), false);
        }
      } else tabs.forEach(function (b) { b.style.removeProperty('--p'); });
      raf = requestAnimationFrame(loop);
    }
    function kick() { if (!raf && visible && !RM) raf = requestAnimationFrame(loop); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) { if (auto) autoStart = performance.now() - 0; kick(); } }, { threshold: 0.15 }).observe(stage || cv);
    } else visible = true;
    document.addEventListener('visibilitychange', kick);
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(cv); else window.addEventListener('resize', resize);
    setMode(mode, false);
    resize();
    if (RM) { root.classList.add('is-static'); draw(modeT + 2600); }
    kick();
  }

  /* ---------------- Frase che si illumina parola per parola ---------------- */
  var words = [];
  function Statement(el) {
    var txt = el.textContent.replace(/\s+/g, ' ').trim(); el.textContent = '';
    var spans = txt.split(' ').map(function (w, i, a) {
      var s = document.createElement('span'); s.textContent = w; el.appendChild(s);
      if (i < a.length - 1) el.appendChild(document.createTextNode(' '));
      return s;
    });
    words.push({ el: el, spans: spans });
  }
  function paintWords() {
    var vh = window.innerHeight;
    words.forEach(function (w) {
      var r = w.el.getBoundingClientRect();
      var p = clamp((vh * 0.88 - r.top) / (vh * 0.5 + r.height * 0.5), 0, 1);
      var n = p * (w.spans.length + 1);
      w.spans.forEach(function (s, i) { s.style.opacity = RM ? 1 : clamp(n - i, 0.16, 1).toFixed(2); });
    });
  }

  /* ---------------- Calcolatore: quanti pannelli servono ---------------- */
  function Size(root) {
    var cv = root.querySelector('canvas'), ctx = cv.getContext('2d');
    var inW = root.querySelector('[data-dfs-w]'), inL = root.querySelector('[data-dfs-l]');
    var out = function (k) { return root.querySelector('[data-dfs-o="' + k + '"]'); };
    var segP = [].slice.call(root.querySelectorAll('[data-dfs-p]')), segM = [].slice.call(root.querySelectorAll('[data-dfs-m]'));
    var mail = root.querySelector('[data-dfs-mail]');
    var panel = 0.6, model = segM.length ? segM[0].getAttribute('data-dfs-m') : 'MirrorFloor';
    var cols = 0, rows = 0, born = {}, raf = 0, visible = false, W = 0, H = 0;
    function fmt(n, d) { return n.toLocaleString('it-IT', { minimumFractionDigits: d || 0, maximumFractionDigits: d || 0 }); }
    function calc() {
      var w = parseFloat(inW.value), l = parseFloat(inL.value);
      cols = Math.max(2, Math.round(w / panel)); rows = Math.max(2, Math.round(l / panel));
      var rw = cols * panel, rl = rows * panel, area = rw * rl, n = cols * rows;
      root.querySelector('[data-dfs-wv]').textContent = fmt(w, 1) + ' m';
      root.querySelector('[data-dfs-lv]').textContent = fmt(l, 1) + ' m';
      out('n').textContent = fmt(n);
      out('dim').textContent = fmt(rw, 1) + ' × ' + fmt(rl, 1) + ' m';
      out('area').textContent = fmt(area, 1) + ' m²';
      out('ppl').textContent = fmt(Math.floor(area / 0.5));
      out('ramp').textContent = fmt(2 * (cols + rows)) + ' + 4 angolari';
      var cm = Math.round(panel * 100);
      var subj = 'Preventivo LUMLY ' + model + ' ' + fmt(rw, 1) + ' x ' + fmt(rl, 1) + ' m';
      var body = 'Buongiorno,\nvorrei un preventivo personalizzato per:\n\nModello: LUMLY ' + model + '\nPannelli: ' + cm + ' × ' + cm + ' cm\nDimensione pista: ' + fmt(rw, 1) + ' × ' + fmt(rl, 1) + ' m (' + n + ' pannelli)\n\nLocation e data dell\'evento:\n';
      if (mail) mail.href = 'mailto:info@lumly.it?subject=' + encodeURIComponent(subj) + '&body=' + encodeURIComponent(body);
      var now = performance.now();
      for (var j = 0; j < rows; j++) for (var i = 0; i < cols; i++) { var k = i + ',' + j; if (!born[k]) born[k] = now + (i + j) * 18; }
      kick(); if (RM) draw(now + 99999);
    }
    function resize() { var r = cv.getBoundingClientRect(); if (!r.width) return; W = r.width; H = r.height; cv.width = Math.round(W * DPR); cv.height = Math.round(H * DPR); ctx.setTransform(DPR, 0, 0, DPR, 0, 0); draw(performance.now()); }
    function draw(t) {
      if (!W) return;
      ctx.clearRect(0, 0, W, H);
      var maxC = 20, pad = 18, cell = Math.min((W - pad * 2) / Math.max(cols, 1), (H - pad * 2) / Math.max(rows, 1), (W - pad * 2) / 8);
      var gw = cell * cols, gh = cell * rows, x0 = (W - gw) / 2, y0 = (H - gh) / 2, busy = false;
      ctx.fillStyle = 'rgba(255,255,255,.04)'; ctx.fillRect(x0 - 6, y0 - 6, gw + 12, gh + 12);
      var warm = model === 'FreeFloor', pix = model === 'PixelFloor', star = model === 'StarFloor', colr = model === 'ColorFloor', s = t / 1000;
      for (var j = 0; j < rows; j++) for (var i = 0; i < cols; i++) {
        var b = born[i + ',' + j] || 0, e = clamp((t - b) / 500, 0, 1); if (e < 1) busy = true;
        var x = x0 + i * cell, y = y0 + j * cell, g = Math.max(1, cell * 0.05), sz = cell - g * 2;
        ctx.fillStyle = '#0a0a0c'; ctx.fillRect(x + g, y + g, sz, sz);
        if (star) {
          for (var q2 = 0; q2 < 6; q2++) { var hx = hash(i * 5 + q2, j * 9 + q2), hy = hash(i * 3 + q2 * 7, j + q2), tw = 0.5 + 0.5 * Math.sin(s * (1.5 + hy * 2) + hx * 30);
            ctx.fillStyle = 'rgba(240,244,255,' + (0.2 + 0.8 * tw * tw) * e + ')'; ctx.fillRect(x + g + hx * (sz - 2), y + g + hy * (sz - 2), Math.max(1, cell * 0.04), Math.max(1, cell * 0.04)); }
        } else if (colr) {
          var pl = [[245, 166, 35], [235, 60, 120], [40, 200, 230], [140, 80, 240]], cc = pl[(i + j + Math.floor(s * 2)) % 4];
          ctx.fillStyle = rgb(cc, 0.85 * e); ctx.fillRect(x + g, y + g, sz, sz);
        } else if (pix) {
          var v = Math.sin(i * 0.6 + s * 1.2) + Math.sin(j * 0.7 - s) ;
          ctx.fillStyle = rgb(hsl(v * 50 + s * 30, 0.85, 0.42), 0.85 * e); ctx.fillRect(x + g, y + g, sz, sz);
          ctx.strokeStyle = 'rgba(0,0,0,.35)'; ctx.lineWidth = 0.6; var q = sz / 4;
          ctx.beginPath(); for (var m = 1; m < 4; m++) { ctx.moveTo(x + g + q * m, y + g); ctx.lineTo(x + g + q * m, y + g + sz); ctx.moveTo(x + g, y + g + q * m); ctx.lineTo(x + g + sz, y + g + q * m); } ctx.stroke();
        } else {
          var col = warm ? [255, 238, 205] : AMBER, R = 4;
          for (var r = 0; r < R; r++) {
            var k = 1 - r / R, hs = sz / 2 * (0.15 + 0.82 * k), cx = x + cell / 2, cy = y + cell / 2;
            ctx.strokeStyle = rgb(col, Math.pow(k, 1.6) * e * (0.85 + 0.15 * Math.sin(s * 2 + i + j)));
            ctx.lineWidth = Math.max(0.6, cell * 0.035); ctx.strokeRect(cx - hs, cy - hs, hs * 2, hs * 2);
          }
        }
      }
      return busy || pix || star || colr;
    }
    function loop(t) { raf = 0; if (!visible) return; if (draw(t) && !RM) raf = requestAnimationFrame(loop); }
    function kick() { if (!raf && visible && !RM) raf = requestAnimationFrame(loop); }
    function seg(list, attr, cb) {
      list.forEach(function (b) {
        b.addEventListener('click', function () {
          list.forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          cb(b.getAttribute(attr));
        });
      });
    }
    seg(segP, 'data-dfs-p', function (v) { panel = parseFloat(v); born = {}; calc(); });
    seg(segM, 'data-dfs-m', function (v) { model = v; born = {}; calc(); });
    [inW, inL].forEach(function (inp) {
      inp.addEventListener('input', function () {
        var p = (inp.value - inp.min) / (inp.max - inp.min) * 100; inp.style.setProperty('--fill', p + '%'); calc();
      });
      inp.dispatchEvent(new Event('input'));
    });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) { born = {}; calc(); } }, { threshold: 0.2 }).observe(cv);
    else visible = true;
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(cv); else window.addEventListener('resize', resize);
    resize(); calc();
  }

  /* ---------------- Entrate in dissolvenza per le schede foto ---------------- */
  function reveals() {
    var els = [].slice.call(document.querySelectorAll('.lgx:not(.dfx-rv), [data-dfx-rv]:not(.dfx-rv)'));
    if (!els.length || RM || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el, i) {
      var sib = el.parentElement ? [].indexOf.call(el.parentElement.children, el) : 0;
      el.classList.add('dfx-rv'); el.style.transitionDelay = Math.min(sib, 5) * 70 + 'ms'; io.observe(el);
    });
  }

  function init() {
    document.querySelectorAll('[data-df-lab]:not([data-ok])').forEach(function (el) { el.setAttribute('data-ok', ''); Lab(el); });
    document.querySelectorAll('[data-df-size]:not([data-ok])').forEach(function (el) { el.setAttribute('data-ok', ''); Size(el); });
    document.querySelectorAll('[data-df-words]:not([data-ok])').forEach(function (el) { el.setAttribute('data-ok', ''); Statement(el); });
    reveals(); paintWords();
  }
  var ticking = false;
  window.addEventListener('scroll', function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; paintWords(); }); }, { passive: true });
  window.addEventListener('resize', paintWords);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
